import { AnswerMode } from "../../answer-modes/AnswerModeContainer/AnswerMode";
import { OverviewContentWrapper } from "./OverviewContentWrapper";

interface Props {
  availableModes: AnswerMode[];
}

export const GenericOverviewContent = ({ availableModes }: Props) => {
  // 1. Group modes based on their context requirements
  // General assistants show up regardless of documents
  const generalModes = availableModes.filter(
    (m) => m.contextRequirement === "any",
  );

  // Document tools only appear when files are uploaded
  const documentSpecificModes = availableModes.filter(
    (m) => m.contextRequirement === "documents",
  );

  return (
    <OverviewContentWrapper>
      <h3>{"Features of MB Chat"}</h3>
      <p>
        The chatbot is designed to be your proactive partner. You can interact
        with it in two ways: using its general knowledge for brainstorming and
        coding, or using "Chat with Document" to ask specific questions about
        your uploaded files. When using documents, every answer is accompanied
        by a link to the relevant source PDF.
      </p>

      <h3>{"Limitations"}</h3>
      <p>
        Only PDF files are supported for document upload. Certain complex
        queries may not be fully supported during this beta phase.
      </p>

      <h3>{"Best Practices"}</h3>
      <p>
        <b>Mode Flexibility:</b> Most modes (like Coding or Writing) work with
        and without documents. If documents are present, these modes will
        prioritize information found within your files while maintaining their
        specialized persona.
      </p>
      <p>
        <b>Prompt Engineering:</b> For the best results, provide context, define
        a clear role, and specify your anticipated output format. Use
        specialized modes to automate this process.
      </p>

      <h3>{"Chatbot Modes"}</h3>

      <h4>{"General Assistants"}</h4>
      <p>
        These modes are always available and influence how the AI structures its
        logic and tone:
      </p>
      <ul>
        {generalModes.map((mode) => (
          <li key={mode.id}>
            <b>{mode.name}:</b> {mode.description || mode.placeholder}
          </li>
        ))}
      </ul>

      {documentSpecificModes.length > 0 && (
        <>
          <h4>{"Document Insights"}</h4>
          <p>
            These specialized modes appear automatically when you upload 1 or
            more documents (Note: "Compare" requires at least 2 documents):
          </p>
          <ul>
            {documentSpecificModes.map((mode) => (
              <li key={mode.id}>
                <b style={{ color: mode.color }}>{mode.name}:</b>{" "}
                {mode.description || mode.placeholder}
              </li>
            ))}
          </ul>
        </>
      )}
    </OverviewContentWrapper>
  );
};
